/* LB 1-11 v41: arreglo de los círculos de color de las tarjetas tras deslizar la foto con el dedo.
   Varios manejadores antiguos (custom-live-…scroll17.js) llevaban la galería a una posición que ya no existe
   y en iPhone el scrollTo se ignora mientras la foto aún se mueve por inercia. Este archivo se ejecuta DESPUÉS de ellos,
   deja la foto elegida en la primera diapositiva Y en la que se está viendo, frena la inercia y vuelve a la primera. */
(function () {
  if (window.lbCardColorFixReady) return;
  window.lbCardColorFixReady = true;
  var BTN = '[data-lb-card-color-button]';
  function btnFrom(ev) {
    var t = ev.target;
    if (t && t.closest) { var b = t.closest(BTN); if (b) return b; }
    var tc = ev.changedTouches && ev.changedTouches[0];
    var x = tc ? tc.clientX : ev.clientX, y = tc ? tc.clientY : ev.clientY;
    if (typeof x === 'number' && typeof y === 'number') {
      var el = document.elementFromPoint(x, y);
      if (el && el.closest) return el.closest(BTN);
    }
    return null;
  }
  function setImg(img, src, srcset) {
    if (!img) return;
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset.replace(/\s+/g, ' ').trim()); else img.removeAttribute('srcset');
  }
  function apply(btn) {
    var sel = btn.closest('[data-lb-card-color-selector]');
    if (!sel) return;
    var card = sel.closest('.card-wrapper, .product-card-wrapper, .card, .grid__item, .slider__slide');
    if (!card) return;
    var src = btn.getAttribute('data-image-src'), srcset = btn.getAttribute('data-image-srcset');
    if (!src) return;
    Array.prototype.forEach.call(sel.querySelectorAll(BTN), function (b) { b.classList.toggle('is-active', b === btn); });
    var g = card.querySelector('.lb-card-media-gallery');
    if (!g) return;
    var slides = Array.prototype.slice.call(g.querySelectorAll('.lb-card-media-slide:not([data-lb-card-clone="true"])'));
    if (!slides.length) return;
    var center = g.scrollLeft + g.clientWidth / 2, vis = slides[0], dist = Infinity;
    slides.forEach(function (s) { var d = Math.abs(center - (s.offsetLeft + s.offsetWidth / 2)); if (d < dist) { dist = d; vis = s; } });
    setImg(slides[0].querySelector('img'), src, srcset);
    if (vis !== slides[0]) setImg(vis.querySelector('img'), src, srcset);
    /* frenar la inercia y volver a la primera foto */
    g.style.setProperty('overflow-x', 'hidden', 'important');
    g.style.setProperty('scroll-snap-type', 'none', 'important');
    g.scrollLeft = 0;
    try { g.scrollTo({ left: 0, behavior: 'auto' }); } catch (e) {}
    window.setTimeout(function () {
      g.scrollLeft = 0;
      g.style.setProperty('overflow-x', 'auto', 'important');
      g.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
      g.scrollLeft = 0;
    }, 120);
    /* los manejadores antiguos lanzan un scroll suave hacia una posición vieja (la última foto): se corrige varias veces */
    [60, 200, 320, 480, 700, 1000].forEach(function (ms) {
      window.setTimeout(function () {
        if (g.scrollLeft > 2) {
          g.style.setProperty('scroll-snap-type', 'none', 'important');
          g.scrollLeft = 0;
          window.setTimeout(function () { g.style.setProperty('scroll-snap-type', 'x mandatory', 'important'); g.scrollLeft = 0; }, 40);
        }
      }, ms);
    });
  }
  function handler(ev) {
    var b = btnFrom(ev);
    if (!b) return;
    window.setTimeout(function () { apply(b); }, 0);
    window.setTimeout(function () { apply(b); }, 160);
  }
  ['pointerup', 'touchend', 'click'].forEach(function (n) { document.addEventListener(n, handler, true); });
})();
